import { createApp } from 'vue'
import App from './MainCard.vue'

createApp(App).mount('#app')
